/**
 * 
 * PRIVATE_ID 电影小镇订制版
 * 
 * */ 
export const PRIVATE_ID  = 890;

/**
 * 
 * HOTEL_URL 电影小镇酒店链接跳转地址
 * 
 * */ 
export const HOTEL_URL  = "javascript:;";



// WEBPACK FOOTER //
// ./src/common/consts.js